import { request } from '@umijs/max';

// 获取质押金列表
export async function getPledgeList(
    params: API.PledgeListParams,
    options?: { [key: string]: any },
) {
    return request<API.PledgeListResult>('/pledge', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取质押金日志列表
export async function getPledgeLogList(
    params: API.PledgeLogListParams,
    options?: { [key: string]: any },
) {
    return request<API.PledgeLogListResult>('/pledge/logs/list', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取质押金汇总信息
export async function getPledgeSummary(
    options?: { [key: string]: any },
) {
    return request<API.PledgeSummaryResult>('/pledge/summary', {
        method: 'GET',
        ...(options || {}),
    });
}

// 质押金转移
export async function transferPledge(
    data: API.TransferPledgeDto,
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<null>>('/pledge/transfer', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data,
        ...(options || {}),
    });
} 